/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateTransactionProductAliasRequest,
  GetTransactionRebateTotalsRequest,
  ProductAliasDTO,
  RevokeTransactionProductAliasRequest,
  SearchTransactionV2Request,
  SearchTransactionsResponse,
  SetQuoteNumberRequest,
  TransactionBulkActionRequest,
  TransactionDto,
  TransactionProductMatchReviewDTO,
  TransactionRebateTotalsDTO,
  TransactionSelectionResult,
  UpdateTransactionRequest,
  UpdateTransactionResponse
} from '../model';

import { apiRequest } from '../../client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Enhanced search with complex filtering, multiple sorts, and transaction display rules.
 * @summary Search Transactions.
 */
export const searchTransactions = (
    searchTransactionV2Request: SearchTransactionV2Request,
 options?: SecondParameter<typeof apiRequest<SearchTransactionsResponse>>,) => {
      return apiRequest<SearchTransactionsResponse>(
      {url: `/transactions/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchTransactionV2Request
    },
      options);
    }
  /**
 * Aggregates rebate totals for all transactions that match the search criteria.
 * @summary Get Transaction Rebate Totals.
 */
export const getTransactionRebateTotals = (
    getTransactionRebateTotalsRequest: GetTransactionRebateTotalsRequest,
 options?: SecondParameter<typeof apiRequest<TransactionRebateTotalsDTO>>,) => {
      return apiRequest<TransactionRebateTotalsDTO>(
      {url: `/transactions/rebate-totals/v2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getTransactionRebateTotalsRequest
    },
      options);
    }
  /**
 * Get a transaction.
 * @summary Get Transaction.
 */
export const getTransaction = (
    transactionID: string,
 options?: SecondParameter<typeof apiRequest<TransactionDto>>,) => {
      return apiRequest<TransactionDto>(
      {url: `/transactions/${transactionID}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Get the product-match review context for a transaction row.
 */
export const getProductMatchReview = (
    transactionID: string,
 options?: SecondParameter<typeof apiRequest<TransactionProductMatchReviewDTO>>,) => {
      return apiRequest<TransactionProductMatchReviewDTO>(
      {url: `/transactions/${transactionID}/product-match-review`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Confirm the suggested product identifier as a distributor-scoped alias.
 */
export const createProductAliasForTransaction = (
    transactionID: string,
    createTransactionProductAliasRequest: CreateTransactionProductAliasRequest,
 options?: SecondParameter<typeof apiRequest<ProductAliasDTO>>,) => {
      return apiRequest<ProductAliasDTO>(
      {url: `/transactions/${transactionID}/product-alias`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTransactionProductAliasRequest
    },
      options);
    }
  /**
 * @summary Soft-revoke a confirmed distributor-scoped alias from a transaction row.
 */
export const revokeTransactionProductAlias = (
    transactionID: string,
    revokeTransactionProductAliasRequest: RevokeTransactionProductAliasRequest,
 options?: SecondParameter<typeof apiRequest<ProductAliasDTO>>,) => {
      return apiRequest<ProductAliasDTO>(
      {url: `/transactions/${transactionID}/product-alias/revoke`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: revokeTransactionProductAliasRequest
    },
      options);
    }
  /**
 * @summary Dismiss a transaction's product-match review: the distributor sets the proposed match aside
until it is restored.
 */
export const dismissTransactionProductMatch = (
    transactionID: string,
 options?: SecondParameter<typeof apiRequest<void>>,) => {
      return apiRequest<void>(
      {url: `/transactions/${transactionID}/product-match-review/dismiss`, method: 'POST'
    },
      options);
    }
  /**
 * @summary Restore a dismissed transaction's product-match review.
 */
export const restoreTransactionProductMatch = (
    transactionID: string,
 options?: SecondParameter<typeof apiRequest<void>>,) => {
      return apiRequest<void>(
      {url: `/transactions/${transactionID}/product-match-review/dismiss`, method: 'DELETE'
    },
      options);
    }
  /**
 * Update a transaction.
 * @summary Update Transaction.
 */
export const updateTransaction = (
    updateTransactionRequest: UpdateTransactionRequest,
 options?: SecondParameter<typeof apiRequest<UpdateTransactionResponse>>,) => {
      return apiRequest<UpdateTransactionResponse>(
      {url: `/transactions`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTransactionRequest
    },
      options);
    }
  /**
 * Queue the selected unclaimed transactions for validation, scoped to the caller's distributor organization and current partner.
 * @summary Validate Transactions.
 */
export const validateTransactions = (
    transactionBulkActionRequest: TransactionBulkActionRequest,
 options?: SecondParameter<typeof apiRequest<TransactionSelectionResult>>,) => {
      return apiRequest<TransactionSelectionResult>(
      {url: `/transactions/validate`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: transactionBulkActionRequest
    },
      options);
    }
  /**
 * Clear the quote numbers on the eligible selected transactions and queue them for re-validation so the quote lookup re-runs.
 * @summary Match Quote Numbers.
 */
export const matchQuoteNumbers = (
    transactionBulkActionRequest: TransactionBulkActionRequest,
 options?: SecondParameter<typeof apiRequest<TransactionSelectionResult>>,) => {
      return apiRequest<TransactionSelectionResult>(
      {url: `/transactions/match-quote-numbers/v2`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: transactionBulkActionRequest
    },
      options);
    }
  /**
 * Set one quote number on the eligible selected transactions and queue them for re-validation.
 * @summary Set Quote Number.
 */
export const setQuoteNumber = (
    setQuoteNumberRequest: SetQuoteNumberRequest,
 options?: SecondParameter<typeof apiRequest<TransactionSelectionResult>>,) => {
      return apiRequest<TransactionSelectionResult>(
      {url: `/transactions/quote-number`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setQuoteNumberRequest
    },
      options);
    }
  /**
 * Archive the selected active, unclaimed transactions. Claimed transactions are archived only with their claim.
 * @summary Archive Transactions.
 */
export const archiveTransactions = (
    transactionBulkActionRequest: TransactionBulkActionRequest,
 options?: SecondParameter<typeof apiRequest<TransactionSelectionResult>>,) => {
      return apiRequest<TransactionSelectionResult>(
      {url: `/transactions/archive`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: transactionBulkActionRequest
    },
      options);
    }
  /**
 * Restore the selected archived, unclaimed transactions, and re-validate them.
 * @summary Unarchive Transactions.
 */
export const restoreArchivedTransactions = (
    transactionBulkActionRequest: TransactionBulkActionRequest,
 options?: SecondParameter<typeof apiRequest<TransactionSelectionResult>>,) => {
      return apiRequest<TransactionSelectionResult>(
      {url: `/transactions/restore`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: transactionBulkActionRequest
    },
      options);
    }
  export type SearchTransactionsResult = NonNullable<Awaited<ReturnType<typeof searchTransactions>>>
export type GetTransactionRebateTotalsResult = NonNullable<Awaited<ReturnType<typeof getTransactionRebateTotals>>>
export type GetTransactionResult = NonNullable<Awaited<ReturnType<typeof getTransaction>>>
export type GetProductMatchReviewResult = NonNullable<Awaited<ReturnType<typeof getProductMatchReview>>>
export type CreateProductAliasForTransactionResult = NonNullable<Awaited<ReturnType<typeof createProductAliasForTransaction>>>
export type RevokeTransactionProductAliasResult = NonNullable<Awaited<ReturnType<typeof revokeTransactionProductAlias>>>
export type DismissTransactionProductMatchResult = NonNullable<Awaited<ReturnType<typeof dismissTransactionProductMatch>>>
export type RestoreTransactionProductMatchResult = NonNullable<Awaited<ReturnType<typeof restoreTransactionProductMatch>>>
export type UpdateTransactionResult = NonNullable<Awaited<ReturnType<typeof updateTransaction>>>
export type ValidateTransactionsResult = NonNullable<Awaited<ReturnType<typeof validateTransactions>>>
export type MatchQuoteNumbersResult = NonNullable<Awaited<ReturnType<typeof matchQuoteNumbers>>>
export type SetQuoteNumberResult = NonNullable<Awaited<ReturnType<typeof setQuoteNumber>>>
export type ArchiveTransactionsResult = NonNullable<Awaited<ReturnType<typeof archiveTransactions>>>
export type RestoreArchivedTransactionsResult = NonNullable<Awaited<ReturnType<typeof restoreArchivedTransactions>>>
